import { AbstractControl, FormArray, ValidationErrors, ValidatorFn } from '@angular/forms';

export function totalPercentageMustEqualValidator(
  expectedTotal: number = 100,
  percentageControlName: string = 'percentage'
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === '' || !Array.isArray(control.value)) {
      return null;
    }

    const total = (control as FormArray).controls
      .map(group => group.get(percentageControlName)?.value ?? 0)
      .reduce((sum: number, val: number) => sum + (val ?? 0), 0);

    return total !== expectedTotal ? { totalPercentageNotEqual: { total, expected: expectedTotal } } : null;
  };
}
